import { gql } from "@apollo/client";
import { maxServerDownloadPageSize } from "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import { Platform } from "../../contract/pam.js";
import "rxjs/ajax";
import "moment-timezone";
import { nameOf } from "../../utils/object.js";
import "react-intl";
class UserProfileRequestBuilder extends GqlRequestBuilder {
  buildUpdateAffiliateBtagMutation() {
    return gql`
            mutation UpdateAffiliateBtag($uid: String!, $affiliate: AffiliateInput!) {
                updateAffiliateBtag(uid: $uid, affiliate: $affiliate) {
                    uid
                    affiliate {
                        btag
                    }
                }
            }
        `;
  }
  getUpdateNonWDBalanceMutation() {
    return gql`
            mutation UpdateNonWithdrawableBalance($uid: String!, $amount: Float!) {
                updateNonWithdrawableBalance(uid: $uid, amount: $amount) {
                    uid
                }
            }
        `;
  }
  buildRequest(requestPayload) {
    const filter = this.mapToFilterObject(requestPayload.filter);
    if (filter?.uid?.includes("|") && requestPayload?.fields?.includes("commission_subtypes")) {
      throw new Error("Cannot use muiltiple uid filter with commissionable_subtypes field");
    }
    let response = null;
    if (!this.isFilterContainInvalidValue(filter)) {
      this.validateFilters(filter);
      response = {
        query: this.buildQuery(requestPayload.fields),
        variables: this.getGqlPageArgs(filter)
      };
    }
    return response;
  }
  buildDownloadRequest(downloadRequestPayload) {
    const filter = this.mapToFilterObject(downloadRequestPayload.filter);
    const queryArgs = this.getGqlPageArgs(filter);
    return {
      query: this.buildExportQuery(),
      variables: {
        report_name: downloadRequestPayload.report_name,
        filter: queryArgs?.filter,
        sort: queryArgs?.sort,
        start: 0,
        end: maxServerDownloadPageSize,
        fields: downloadRequestPayload.columns.map((column) => ({
          column_name: column.name,
          field: column.field
        }))
      }
    };
  }
  validateFilters(_filter) {
    return;
  }
  buildFilter(filter) {
    const referrerId = this.toGQLStringFilter(filter, "referrerPlayerId") ?? this.toGQLStringFilter(filter, "defaultReferrerPlayerId");
    const isDownstream = filter.isDownstream !== void 0 && filter.isDownstream !== null ? this.toGQLBooleanFilter(filter, "isDownstream") : this.toGQLBooleanFilter(filter, "defaultIsDownstream");
    return {
      filter: {
        text: this.getGQLTextFilter([
          ...Object.keys(this.userProfileTextFilterFieldsMapper).map(
            (key) => this.toGQLTextFilter(
              this.userProfileTextFilterFieldsMapper[key],
              filter[key],
              this.transformTextMapper[key]
            )
          ),
          filter.networks_PKW ? {
            text: Platform.Pkw,
            search_in: [`${nameOf("networks")}.${nameOf("platform")}`]
          } : null,
          filter.networks_BL ? {
            text: Platform.Bl,
            search_in: [`${nameOf("networks")}.${nameOf("platform")}`]
          } : null
        ]),
        not_empty: this.getNotEmptyFields(filter),
        birthday: this.toGQLDateRange(filter.birthdayFrom, filter.birthdayTo),
        date_of_joining: this.toGQLDateRange(filter.joinedFrom, filter.joinedTo),
        account_status: this.toGQLMultiselectFilter(filter, "accountStatus"),
        deposit_status: this.toGQLMultiselectFilter(filter, "depositStatus"),
        withdrawal_status: this.toGQLMultiselectFilter(filter, "withdrawalStatus"),
        kyc_status: this.toGQLMultiselectFilter(filter, "kycStatus"),
        security_cases: this.toGQLMultiselectFilter(filter, "securityCases"),
        players_groups: this.toGQLMultiselectFilter(filter, "playersGroups"),
        referrer: referrerId ? {
          referrer_player_id: referrerId,
          is_downstream: isDownstream,
          is_agent: true
        } : void 0,
        casino_ggr: this.toGQLNumberRangeFilter(filter?.casinoGgrFrom, filter?.casinoGgrTo),
        poker_ggr: this.toGQLNumberRangeFilter(filter?.pokerGgrFrom, filter?.pokerGgrTo),
        sports_ggr: this.toGQLNumberRangeFilter(filter?.sportsGgrFrom, filter?.sportsGgrTo),
        deposit_total: this.toGQLNumberRangeFilter(filter?.depositTotalFrom, filter?.depositTotalTo),
        withdrawal_total: this.toGQLNumberRangeFilter(filter?.withdrawalTotalFrom, filter?.withdrawalTotalTo),
        is_agent: filter.isAgent !== void 0 ? this.toGQLBooleanFilter(filter, "isAgent") : void 0,
        channel: this.toGQLMultiselectFilter(filter, "channel"),
        aal: this.toGQLMultiselectFilter(filter, "aal", true),
        license_type: this.toGQLMultiselectFilter(filter, "licenseType"),
        brand: this.toGQLMultiselectFilter(filter, "brand")
      },
      uid: filter.uid ?? ""
    };
  }
  getNotEmptyFields(filter) {
    const notEmptyFields = [];
    if (filter?.isMasterAgentOrHasReferrer) {
      notEmptyFields.push("agent_info.bo_agent_id", "agent_info.keycloak_user_id", "referral.inviting_user_id");
    }
    return notEmptyFields.length > 0 ? notEmptyFields : void 0;
  }
  getNetworksQueryItems() {
    return ["networks.uid", "networks.platform"];
  }
  getBirthdayQueryItems() {
    return ["birthday.seconds"];
  }
  getDateOfJoiningQueryItems() {
    return ["date_of_joining.seconds"];
  }
  getContactQueryItems() {
    return [
      "contact.email",
      ...this.getContactMobileQueryItems(),
      "contact.verified_email",
      ...this.getVerifiedContactMobileQueryItems()
    ];
  }
  getVerifiedContactMobileQueryItems() {
    return ["contact.verified_mobile.area", "contact.verified_mobile.mobile", "contact.verified_mobile.full_number"];
  }
  getContactMobileQueryItems() {
    return ["contact.mobile.area", "contact.mobile.mobile", "contact.mobile.full_number"];
  }
  getAddressQueryItems() {
    return [
      "address.address",
      "address.city",
      "address.state",
      "address.country",
      "address.post_code",
      ...this.getAddressCountryQueryItems()
    ];
  }
  getAddressCountryQueryItems() {
    return ["address.country_info.iso_alpha2_code", "address.country_info.name"];
  }
  getSecuritySettingsQueryItems() {
    return ["security_settings.is_2fa_enabled", "security_settings.is_challenge_questions_enabled"];
  }
  getBlacklistQueryItems() {
    return ["black_list.items.type", "black_list.items.key"];
  }
  getDevicesQueryItems() {
    return ["devices.uuid", "devices.model", "devices.name", "devices.operating_system"];
  }
  getSecurityCasesQueryItems() {
    return ["security_cases.type", "security_cases.case_id"];
  }
  getLatestLoginQueryItems() {
    return [
      "latest_login.login_type",
      "latest_login.login_status",
      "latest_login.ip",
      "latest_login.isp",
      "latest_login.session_id",
      "latest_login.recaptcha_score",
      "latest_login.recaptcha_reasons",
      "latest_login.ip_quality_score",
      ...this.getLatestLoginLoggedAtQueryItems(),
      ...this.getLatestLoginLocationQueryItems(),
      ...this.getLatestDeviceQueryItems()
    ];
  }
  getLatestLoginLoggedAtQueryItems() {
    return ["latest_login.logged_at_ts.seconds"];
  }
  getLatestLoginLocationQueryItems() {
    return [
      "latest_login.location.country",
      "latest_login.location.state",
      "latest_login.location.city",
      "latest_login.location.latitude",
      "latest_login.location.longitude"
    ];
  }
  getLatestDeviceQueryItems() {
    return [
      "latest_login.device.mac_address",
      "latest_login.device.model",
      "latest_login.device.uuid",
      "latest_login.device.name",
      "latest_login.device.operating_system"
    ];
  }
  getFinanceQueryItems() {
    return [
      ...this.getFinanceDepositQueryItems(),
      ...this.getFinanceWithdrawalQueryItems(),
      ...this.getFinanceGRRLifetimeQueryItems(),
      "finance.generated_rake",
      "finance.balance",
      "finance.ggr",
      "finance.lifetime_bonus",
      "finance.bonus_ratio",
      "finance.casino_coin_balance",
      "finance.withdrawable_balance"
    ];
  }
  getFinanceDepositQueryItems() {
    return [...this.getFinanceDepositTotalQueryItems(), ...this.getFinanceDepositPerMethodQueryItems()];
  }
  getFinanceDepositTotalQueryItems() {
    return ["finance.deposit.total.successful_amount"];
  }
  getFinanceDepositPerMethodQueryItems() {
    return [
      "finance.deposit.per_method.category",
      "finance.deposit.per_method.group_name",
      "finance.deposit.per_method.successful_amount",
      "finance.deposit.per_method.failed_amount",
      "finance.deposit.per_method.rejected_amount",
      "finance.deposit.per_method.successful_count",
      "finance.deposit.per_method.failed_count",
      "finance.deposit.per_method.rejected_count",
      "finance.deposit.per_method.currency"
    ];
  }
  getFinanceWithdrawalQueryItems() {
    return [...this.getFinanceWithdrawalTotalQueryItems(), ...this.getFinanceWithdrawalPerMethodQueryItems()];
  }
  getFinanceWithdrawalTotalQueryItems() {
    return [
      "finance.withdrawal.total.successful_amount",
      "finance.withdrawal.total.successful_count",
      "finance.withdrawal.total.pending_amount",
      "finance.withdrawal.total.pending_count"
    ];
  }
  getFinanceWithdrawalPerMethodQueryItems() {
    return [
      "finance.withdrawal.per_method.category",
      "finance.withdrawal.per_method.group_name",
      "finance.withdrawal.per_method.successful_amount",
      "finance.withdrawal.per_method.failed_amount",
      "finance.withdrawal.per_method.rejected_amount",
      "finance.withdrawal.per_method.successful_count",
      "finance.withdrawal.per_method.failed_count",
      "finance.withdrawal.per_method.rejected_count",
      "finance.withdrawal.per_method.currency"
    ];
  }
  getFinanceGRRLifetimeQueryItems() {
    return ["finance.ggr_lifetime.casino", "finance.ggr_lifetime.poker", "finance.ggr_lifetime.sports"];
  }
  getLatestKycPaymentDocumentsQueryItems() {
    return [
      "latest_kyc.payment.documents.first_name",
      "latest_kyc.payment.documents.last_name",
      "latest_kyc.payment.documents.gender",
      "latest_kyc.payment.documents.dob",
      "latest_kyc.payment.documents.doc_type",
      "latest_kyc.payment.documents.doc_id_sub_type",
      "latest_kyc.payment.documents.number",
      "latest_kyc.payment.documents.device_verified",
      "latest_kyc.payment.documents.ip_verified",
      "latest_kyc.payment.documents.geolocation_verified"
    ];
  }
  getLatestKycPaymentQueryItems() {
    return [
      ...this.getLatestKycPaymentDocumentsQueryItems(),
      "latest_kyc.payment.id",
      "latest_kyc.payment.account_verification_status"
    ];
  }
  getLatestKycSecurityDocumentsQueryItems() {
    return [
      "latest_kyc.security.documents.first_name",
      "latest_kyc.security.documents.last_name",
      "latest_kyc.security.documents.gender",
      "latest_kyc.security.documents.dob",
      "latest_kyc.security.documents.doc_type",
      "latest_kyc.security.documents.doc_id_sub_type",
      "latest_kyc.security.documents.number",
      "latest_kyc.security.documents.device_verified",
      "latest_kyc.security.documents.ip_verified",
      "latest_kyc.security.documents.geolocation_verified"
    ];
  }
  getLatestKycSecurityQueryItems() {
    return [
      ...this.getLatestKycSecurityDocumentsQueryItems(),
      "latest_kyc.security.id",
      "latest_kyc.security.kyc_case_id",
      "latest_kyc.security.account_verification_status"
    ];
  }
  getLatestKycQueryItems() {
    return [...this.getLatestKycPaymentQueryItems(), ...this.getLatestKycSecurityQueryItems()];
  }
  getAffiliateQueryItems() {
    return ["affiliate.btag"];
  }
  getReferralQueryItems() {
    return [
      "referral.inviting_user_id",
      "referral.inviting_user_username",
      "referral.personal_referral_code",
      "referral.referral_code",
      "referral.referred_at"
    ];
  }
  getAgentInfoQueryItems() {
    return [
      "agent_info.agent_granted_ts.seconds",
      "agent_info.bo_agent_id",
      "agent_info.default_agent_revenue_share_history",
      "agent_info.is_agent"
    ];
  }
  getRegionRelatedInfoQueryItems() {
    return [
      "region_player_info.occupation",
      "region_player_info.tax_id",
      "region_player_info.national_id",
      "region_player_info.nationality",
      "region_player_info.country_of_birth",
      "region_player_info.district"
    ];
  }
  getMarketingInfoQueryItems() {
    return ["marketing_info.register_marketing_code"];
  }
  getLabelsGroupQueryItems() {
    return ["labels.group.id", "labels.group.color", "labels.group.name"];
  }
  getLabelsQueryItems() {
    return ["labels.id", "labels.name", ...this.getLabelsGroupQueryItems()];
  }
  getCommissionSubtypesQueryItems() {
    return ["commission_subtypes"];
  }
  getMasterAgentQueryItems() {
    return ["commission_subtypes", "master_agent_id"];
  }
  buildQuery(fields) {
    return gql`
            query GetUserItems($filter: UserProfileFilter, $uid: String!, $sort: Sorting, $start: Int, $end: Int) {
                getUserProfiles(filter: $filter, sort: $sort, start: $start, end: $end) {
                    items {
                        uid
                        networks @include(if: ${this.hasAnyField(fields, this.getNetworksQueryItems())}) {
                            uid @include(if: ${this.hasField(fields, "networks.uid")})
                            platform @include(if: ${this.hasField(fields, "networks.platform")})
                        }
                        username @include(if: ${this.hasField(fields, "username")})
                        nickname @include(if: ${this.hasField(fields, "nickname")})
                        first_name @include(if: ${this.hasField(fields, "first_name")})
                        last_name @include(if: ${this.hasField(fields, "last_name")})
                        contact  @include(if: ${this.hasAnyField(fields, this.getContactQueryItems())}) {
                            email @include(if: ${this.hasField(fields, "contact.email")})
                            mobile  @include(if: ${this.hasAnyField(fields, this.getContactMobileQueryItems())}) {
                                area @include(if: ${this.hasField(fields, "contact.mobile.area")})
                                mobile @include(if: ${this.hasField(fields, "contact.mobile.mobile")})
                                full_number @include(if: ${this.hasField(fields, "contact.mobile.full_number")})
                            }
                            verified_email @include(if: ${this.hasField(fields, "contact.verified_email")})
                            verified_mobile @include(if: ${this.hasAnyField(fields, this.getVerifiedContactMobileQueryItems())}) {
                                area @include(if: ${this.hasField(fields, "contact.verified_mobile.area")})
                                mobile @include(if: ${this.hasField(fields, "contact.verified_mobile.mobile")})
                                full_number @include(if: ${this.hasField(fields, "contact.verified_mobile.full_number")})
                            }
                        }
                        birthday @include(if: ${this.hasAnyField(fields, this.getBirthdayQueryItems())}) {
                            seconds @include(if: ${this.hasField(fields, "birthday.seconds")})
                        }
                        gender @include(if: ${this.hasField(fields, "gender")})
                        address @include(if: ${this.hasAnyField(fields, this.getAddressQueryItems())}) {
                            address @include(if: ${this.hasField(fields, "address.address")})
                            city @include(if: ${this.hasField(fields, "address.city")})
                            state @include(if: ${this.hasField(fields, "address.state")})
                            country @include(if: ${this.hasField(fields, "address.country")})
                            country_info @include(if: ${this.hasAnyField(fields, this.getAddressCountryQueryItems())}) {
                                iso_alpha2_code @include(if: ${this.hasField(fields, "address.country_info.iso_alpha2_code")})
                                name @include(if: ${this.hasField(fields, "address.country_info.name")})
                            }
                            post_code @include(if: ${this.hasField(fields, "address.post_code")})
                        }
                        date_of_joining  @include(if: ${this.hasAnyField(fields, this.getDateOfJoiningQueryItems())}) {
                            seconds @include(if: ${this.hasField(fields, "date_of_joining.seconds")})
                        }
                        account_status @include(if: ${this.hasField(fields, "account_status")})
                        casino_status @include(if: ${this.hasField(fields, "casino_status")})
                        sportsbook_status @include(if: ${this.hasField(fields, "sportsbook_status")})
                        security_settings @include(if: ${this.hasAnyField(fields, this.getSecuritySettingsQueryItems())}) {
                            is_2fa_enabled @include(if: ${this.hasField(fields, "security_settings.is_2fa_enabled")})
                            is_challenge_questions_enabled @include(if: ${this.hasField(
      fields,
      "security_settings.is_challenge_questions_enabled"
    )})
                        }
                        black_list @include(if: ${this.hasAnyField(fields, this.getBlacklistQueryItems())}) {
                            items @include(if: ${this.hasAnyField(fields, this.getBlacklistQueryItems())}) {
                                type @include(if: ${this.hasField(fields, "black_list.items.type")})
                                key @include(if: ${this.hasField(fields, "black_list.items.key")})
                            }
                        }
                        ip_addresses @include(if: ${this.hasField(fields, "ip_addresses")})
                        devices  @include(if: ${this.hasAnyField(fields, this.getDevicesQueryItems())}) {
                            uuid @include(if: ${this.hasField(fields, "devices.uuid")})
                            model @include(if: ${this.hasField(fields, "devices.model")})
                            name @include(if: ${this.hasField(fields, "devices.name")})
                            operating_system @include(if: ${this.hasField(fields, "devices.operating_system")})
                        }
                        security_cases @include(if: ${this.hasAnyField(fields, this.getSecurityCasesQueryItems())}) {
                            type @include(if: ${this.hasField(fields, "security_cases.type")})
                            case_id @include(if: ${this.hasField(fields, "security_cases.case_id")})
                            opened_at @include(if: ${this.hasField(fields, "security_cases.opened_at")}) {
                                seconds
                            }
                            closed_at @include(if: ${this.hasField(fields, "security_cases.closed_at")}) {
                                seconds
                            }
                        }
                        latest_login @include(if: ${this.hasAnyField(fields, this.getLatestLoginQueryItems())}) {
                            login_type @include(if: ${this.hasField(fields, "latest_login.login_type")})
                            login_status @include(if: ${this.hasField(fields, "latest_login.login_status")})
                            logged_at_ts  @include(if: ${this.hasAnyField(fields, this.getLatestLoginLoggedAtQueryItems())}) {
                                seconds @include(if: ${this.hasField(fields, "latest_login.logged_at_ts.seconds")})
                            }
                            location @include(if: ${this.hasAnyField(fields, this.getLatestLoginLocationQueryItems())}) {
                                country @include(if: ${this.hasField(fields, "latest_login.location.country")})
                                state @include(if: ${this.hasField(fields, "latest_login.location.state")})
                                city @include(if: ${this.hasField(fields, "latest_login.location.city")})
                                latitude @include(if: ${this.hasField(fields, "latest_login.location.latitude")})
                                longitude @include(if: ${this.hasField(fields, "latest_login.location.longitude")})
                            }
                            ip @include(if: ${this.hasField(fields, "latest_login.ip")})
                            isp @include(if: ${this.hasField(fields, "latest_login.isp")})
                            device @include(if: ${this.hasAnyField(fields, this.getLatestDeviceQueryItems())}) {
                                mac_address @include(if: ${this.hasField(fields, "latest_login.device.mac_address")})
                                model @include(if: ${this.hasField(fields, "latest_login.device.model")})
                                uuid @include(if: ${this.hasField(fields, "latest_login.device.uuid")})
                                name @include(if: ${this.hasField(fields, "latest_login.device.name")})
                                operating_system @include(if: ${this.hasField(fields, "latest_login.device.operating_system")})
                            }
                            session_id
                            correlation_id
                            recaptcha_score @include(if: ${this.hasField(fields, "latest_login.recaptcha_score")})
                            recaptcha_reasons @include(if: ${this.hasField(fields, "latest_login.recaptcha_reasons")})
                            ip_quality_score @include(if: ${this.hasField(fields, "latest_login.ip_quality_score")})
                        }                
                        finance @include(if: ${this.hasAnyField(fields, this.getFinanceQueryItems())}) {
                            deposit @include(if: ${this.hasAnyField(fields, this.getFinanceDepositQueryItems())}) {
                                total @include(if: ${this.hasAnyField(fields, this.getFinanceDepositTotalQueryItems())}) {
                                    successful_amount @include(if: ${this.hasField(fields, "finance.deposit.total.successful_amount")})
                                }
                                per_method  @include(if: ${this.hasAnyField(fields, this.getFinanceDepositPerMethodQueryItems())}) {
                                    category @include(if: ${this.hasField(fields, "finance.deposit.per_method.category")})
                                    group_name @include(if: ${this.hasField(fields, "finance.deposit.per_method.group_name")})
                                    successful_amount @include(if: ${this.hasField(fields, "finance.deposit.per_method.successful_amount")})
                                    failed_amount @include(if: ${this.hasField(fields, "finance.deposit.per_method.failed_amount")})
                                    rejected_amount @include(if: ${this.hasField(fields, "finance.deposit.per_method.rejected_amount")})
                                    successful_count @include(if: ${this.hasField(fields, "finance.deposit.per_method.successful_count")})
                                    failed_count @include(if: ${this.hasField(fields, "finance.deposit.per_method.failed_count")})
                                    rejected_count @include(if: ${this.hasField(fields, "finance.deposit.per_method.rejected_count")})
                                    currency @include(if: ${this.hasField(fields, "finance.deposit.per_method.currency")})
                                }
                            }
                            withdrawal @include(if: ${this.hasAnyField(fields, this.getFinanceWithdrawalQueryItems())}) {
                                total @include(if: ${this.hasAnyField(fields, this.getFinanceWithdrawalTotalQueryItems())}) {
                                    successful_amount @include(if: ${this.hasField(fields, "finance.withdrawal.total.successful_amount")})
                                    successful_count @include(if: ${this.hasField(fields, "finance.withdrawal.total.successful_count")})
                                    pending_amount @include(if: ${this.hasField(fields, "finance.withdrawal.total.pending_amount")})
                                    pending_count @include(if: ${this.hasField(fields, "finance.withdrawal.total.pending_count")})
                                }
                                per_method @include(if: ${this.hasAnyField(fields, this.getFinanceWithdrawalPerMethodQueryItems())}) {
                                    category @include(if: ${this.hasField(fields, "finance.withdrawal.per_method.category")})
                                    group_name @include(if: ${this.hasField(fields, "finance.withdrawal.per_method.group_name")})
                                    successful_amount @include(if: ${this.hasField(
      fields,
      "finance.withdrawal.per_method.successful_amount"
    )})
                                    failed_amount @include(if: ${this.hasField(fields, "finance.withdrawal.per_method.failed_amount")})
                                    rejected_amount @include(if: ${this.hasField(fields, "finance.withdrawal.per_method.rejected_amount")})
                                    successful_count @include(if: ${this.hasField(
      fields,
      "finance.withdrawal.per_method.successful_count"
    )})
                                    failed_count @include(if: ${this.hasField(fields, "finance.withdrawal.per_method.failed_count")})
                                    rejected_count @include(if: ${this.hasField(fields, "finance.withdrawal.per_method.rejected_count")})
                                    currency @include(if: ${this.hasField(fields, "finance.withdrawal.per_method.currency")})
                                }
                            }
                            generated_rake @include(if: ${this.hasField(fields, "finance.generated_rake")})
                            balance @include(if: ${this.hasField(fields, "finance.balance")})
                            ggr @include(if: ${this.hasField(fields, "finance.ggr")})
                            ggr_lifetime @include(if: ${this.hasAnyField(fields, this.getFinanceGRRLifetimeQueryItems())}) {
                                casino @include(if: ${this.hasField(fields, "finance.ggr_lifetime.casino")})
                                poker @include(if: ${this.hasField(fields, "finance.ggr_lifetime.poker")})
                                sports @include(if: ${this.hasField(fields, "finance.ggr_lifetime.sports")})
                            }
                            lifetime_bonus @include(if: ${this.hasField(fields, "finance.lifetime_bonus")})
                            bonus_ratio @include(if: ${this.hasField(fields, "finance.bonus_ratio")})
                            casino_coin_balance @include(if: ${this.hasField(fields, "finance.casino_coin_balance")})
                            p2p_credit @include(if: ${this.hasField(fields, "finance.p2p_credit.successful_amount")}) {
                                successful_amount
                            }
                            p2p_debit @include(if: ${this.hasField(fields, "finance.p2p_debit.successful_amount")}) {
                                successful_amount
                            }
                            withdrawable_balance ${this.hasQueryItem(fields, "finance.withdrawable_balance")}
                            non_withdrawable_balance ${this.hasQueryItem(fields, "finance.non_withdrawable_balance")}
                        }
                        security @include(if: ${this.hasField(fields, "security")}) @client
                        latest_kyc @include(if: ${this.hasAnyField(fields, this.getLatestKycQueryItems())}) {
                            security @include(if: ${this.hasAnyField(fields, this.getLatestKycSecurityQueryItems())}) {
                                id @include(if: ${this.hasField(fields, "latest_kyc.security.id")})
                                kyc_case_id @include(if: ${this.hasField(fields, "latest_kyc.security.kyc_case_id")})
                                account_verification_status @include(if: ${this.hasField(
      fields,
      "latest_kyc.security.account_verification_status"
    )})
                                documents @include(if: ${this.hasAnyField(fields, this.getLatestKycSecurityDocumentsQueryItems())}) {
                                    first_name @include(if: ${this.hasField(fields, "latest_kyc.security.documents.first_name")})
                                    last_name @include(if: ${this.hasField(fields, "latest_kyc.security.documents.last_name")})
                                    gender @include(if: ${this.hasField(fields, "latest_kyc.security.documents.gender")})
                                    dob @include(if: ${this.hasField(fields, "latest_kyc.security.documents.dob")})
                                    doc_type @include(if: ${this.hasField(fields, "latest_kyc.security.documents.doc_type")})
                                    doc_id_sub_type @include(if: ${this.hasField(fields, "latest_kyc.security.documents.doc_id_sub_type")})
                                    number @include(if: ${this.hasField(fields, "latest_kyc.security.documents.number")})
                                    device_verified @include(if: ${this.hasField(fields, "latest_kyc.security.documents.device_verified")})
                                    ip_verified @include(if: ${this.hasField(fields, "latest_kyc.security.documents.ip_verified")})
                                    geolocation_verified @include(if: ${this.hasField(
      fields,
      "latest_kyc.security.documents.geolocation_verified"
    )})
                                }
                            }
                            payment @include(if: ${this.hasAnyField(fields, this.getLatestKycPaymentQueryItems())}) {
                                id @include(if: ${this.hasField(fields, "latest_kyc.payment.id")})
                                account_verification_status @include(if: ${this.hasField(
      fields,
      "latest_kyc.payment.account_verification_status"
    )})
                                documents @include(if: ${this.hasAnyField(fields, this.getLatestKycPaymentDocumentsQueryItems())}) {
                                    first_name @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.first_name")})
                                    last_name @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.last_name")})
                                    gender @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.gender")})
                                    dob @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.dob")})
                                    doc_type @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.doc_type")})
                                    doc_id_sub_type @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.doc_id_sub_type")})
                                    number @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.number")})
                                    device_verified @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.device_verified")})
                                    ip_verified @include(if: ${this.hasField(fields, "latest_kyc.payment.documents.ip_verified")})
                                    geolocation_verified @include(if: ${this.hasField(
      fields,
      "latest_kyc.payment.documents.geolocation_verified"
    )})
                                }
                            }
                        }
                        aml_labels @include(if: ${this.hasField(fields, "aml_labels")})
                        punishment_status @include(if: ${this.hasField(fields, "punishment_status")})
                        withdrawal_status @include(if: ${this.hasField(fields, "withdrawal_status")})
                        deposit_status @include(if: ${this.hasField(fields, "deposit_status")})
                        lobby_access_status @include(if: ${this.hasField(fields, "lobby_access_status")})
                        p2p_transfer_status @include(if: ${this.hasField(fields, "p2p_transfer_status")})
                        p2p_override_status ${this.hasQueryItem(fields, "p2p_override_status")}
                        p2p_status ${this.hasQueryItem(fields, "p2p_status")}
                        business_pool @include(if: ${this.hasField(fields, "business_pool")})
                        platform @include(if: ${this.hasField(fields, "platform")})                        
                        brand @include(if: ${this.hasField(fields, "brand")}) 
                        license_type @include(if: ${this.hasField(fields, "license_type")})
                        pool_id @include(if: ${this.hasField(fields, "pool_id")})
                        countries @include(if: ${this.hasField(fields, "countries")})
                        vpn @include(if: ${this.hasField(fields, "vpn")})
                        marketing_info @include(if: ${this.hasAnyField(fields, this.getMarketingInfoQueryItems())}) {
                            register_marketing_code @include(if: ${this.hasField(fields, "marketing_info.register_marketing_code")})
                        }
                        labels @include(if: ${this.hasAnyField(fields, this.getLabelsQueryItems())}) {
                            id @include(if: ${this.hasField(fields, "labels.id")})
                            name @include(if: ${this.hasField(fields, "labels.name")})
                            group @include(if: ${this.hasAnyField(fields, this.getLabelsGroupQueryItems())}) {
                                id @include(if: ${this.hasField(fields, "labels.group.id")})
                                color @include(if: ${this.hasField(fields, "labels.group.color")})
                                name @include(if: ${this.hasField(fields, "labels.group.name")})
                            }
                        }
                        affiliate @include(if: ${this.hasAnyField(fields, this.getAffiliateQueryItems())}) {
                            btag @include(if: ${this.hasField(fields, "affiliate.btag")})
                        }
                        referral @include(if: ${this.hasAnyField(fields, this.getReferralQueryItems())}) {
                            inviting_user_id @include(if: ${this.hasField(fields, "referral.inviting_user_id")})
                            inviting_user_username @include(if: ${this.hasField(fields, "referral.inviting_user_username")})
                            personal_referral_code @include(if: ${this.hasField(fields, "referral.personal_referral_code")})
                            referral_code @include(if: ${this.hasField(fields, "referral.referral_code")})
                            referred_at @include(if: ${this.hasField(fields, "referral.referred_at")}) {seconds} 
                        }
                        agent_info @include(if: ${this.hasAnyField(fields, this.getAgentInfoQueryItems())}) {
                            agent_granted_ts @include(if: ${this.hasField(fields, "agent_info.agent_granted_ts.seconds")}) {
                                seconds @include(if: ${this.hasField(fields, "agent_info.agent_granted_ts.seconds")})
                            }
                            bo_agent_id @include(if: ${this.hasField(fields, "agent_info.bo_agent_id")})
                            is_agent ${this.hasQueryItem(fields, "agent_info.is_agent")}
                            default_agent_revenue_share_history @include(if: ${this.hasField(
      fields,
      "agent_info.default_agent_revenue_share_history"
    )})
                        }
                        aal @include(if: ${this.hasField(fields, "aal")})
                        region_player_info @include(if: ${this.hasAnyField(fields, this.getRegionRelatedInfoQueryItems())}) {
                            occupation @include(if: ${this.hasField(fields, "region_player_info.occupation")})
                            tax_id @include(if: ${this.hasField(fields, "region_player_info.tax_id")})
                            national_id @include(if: ${this.hasField(fields, "region_player_info.national_id")})
                            nationality @include(if: ${this.hasField(fields, "region_player_info.nationality")})
                            country_of_birth @include(if: ${this.hasField(fields, "region_player_info.country_of_birth")})
                            district @include(if: ${this.hasField(fields, "region_player_info.district")})
                        }
                        channel ${this.hasQueryItem(fields, "channel")}
                    }
                    total_count
                }

                getPlayerReferralLink(uid: $uid) @include(if: ${this.hasField(fields, "referral.personal_referral_link")})

                getMasterAgent(uid: $uid) ${this.hasAnyOfQueryItems(fields, this.getMasterAgentQueryItems())} {
                    uid ${this.hasQueryItem(fields, "master_agent_id")}
                    commission_subtypes ${this.hasAnyOfQueryItems(fields, this.getCommissionSubtypesQueryItems())} {
                        casino
                        poker
                        poker_cash_plo
                        poker_mtt
                        spins
                        sports
                    }
                }
            }
        `;
  }
  userProfileTextFilterFieldsMapper = {
    uid_un_nn_rc: ["uid", "username", "nickname", "referral.personal_referral_code"],
    uid_un_fn_ln_em_ph_rmc: [
      "uid",
      "username",
      "first_name",
      "last_name",
      "contact.email",
      "contact.mobile.full_number",
      "networks.uid",
      "marketing_info.register_marketing_code"
    ],
    uid_un_fn_ln_labels_em_ni_rmc_phone_r: [
      "uid",
      "username",
      "first_name",
      "last_name",
      "labels.name",
      "contact.email",
      "region_player_info.national_id",
      "marketing_info.register_marketing_code",
      "contact.mobile.full_number",
      "affiliate.btag",
      "referral.inviting_user_id"
    ],
    uid_un_nn_em_sc_nuid: ["uid", "username", "nickname", "contact.email", "security_cases.case_id"],
    uid_un_nn_em_l_sc_nuid_ref: [
      "uid",
      "username",
      "nickname",
      "contact.email",
      "labels.name",
      "security_cases.case_id",
      "networks.uid",
      "affiliate.btag",
      "referral.inviting_user_id"
    ],
    uid_un_rmc_em: ["uid", "contact.email", "username", "marketing_info.register_marketing_code"],
    uid: ["uid"],
    firstName: ["first_name"],
    lastName: ["last_name"],
    username: ["username"],
    nickname: ["nickname"],
    email: ["contact.email"],
    phone: ["contact.mobile.full_number"],
    security_cases: ["security_cases.case_id"],
    marketingCode: ["marketing_info.register_marketing_code"],
    labels: ["labels.name"],
    networks_PKW: ["networks.uid"],
    networks_BL: ["networks.uid"],
    referrerId: ["affiliate.btag", "referral.inviting_user_id"],
    nationalId: ["region_player_info.national_id"],
    boUserId_uid: ["agent_info.bo_agent_id", "uid"],
    boUserId: ["agent_info.bo_agent_id"],
    registrationCountry: ["address.country_info.iso_alpha2_code"],
    loginCountry: ["countries"],
    personalReferralCode: ["referral.personal_referral_code"]
  };
  transformTextMapper = {
    email: this.ignoreCase,
    labels: this.phraseSearch,
    registrationCountry: (value) => this.phraseListSearch(value.replaceAll(",", " "), " "),
    loginCountry: (value) => this.phraseListSearch(value.replaceAll(",", " "), " ")
  };
  buildExportQuery() {
    return gql`
            query ExportUserProfiles(
                $filter: UserProfileFilter
                $report_name: String!
                $fields: [ReportField]
                $sort: Sorting
                $start: Int
                $end: Int
            ) {
                exportUserProfiles(filter: $filter, report_name: $report_name, fields: $fields, sort: $sort, end: $end, start: $start) {
                    url
                }
            }
        `;
  }
}
export {
  UserProfileRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
